function setAttributes(element, attributesObject) {
  Object.keys(attributesObject).forEach((key) =>
    element.setAttribute(key, attributesObject[key]),
  );
  return element;
}

const createElement = (el) => (attributes = {}) => {
  const element = document.createElement(el);
  return setAttributes(element, attributes);
};

const createLink = createElement('a');
const createDiv = createElement('div');
const createParagraph = createElement('p');
const createSpan = createElement('span');
const createBold = createElement('b');
const createImage = createElement('img');
const createIcon = createElement('i');
const createFontAwesomeIcon = (iconName) =>
  createIcon({
    class: `fas fa-${iconName}`,
  });

export {
  createBold,
  createDiv,
  createFontAwesomeIcon,
  createImage,
  createLink,
  createParagraph,
  createSpan,
};
